const COUNTRIES = [
    { id: '+7', name: 'Russian Federation', code: 'RU' },
    { id: '+9955', name: 'Georgia', code: 'GE' },
    { id: '+507', name: 'Panama', code: 'PA' },
    { id: '+44', name: 'United Kingdom', code: 'GB' },
    { id: '+992', name: 'Tajikistan', code: 'TJ' },
    { id: '+370', name: 'Lithuania', code: 'LT' },
    { id: '+972', name: 'Israel', code: 'IL' },
    { id: '+996', name: 'Kyrgyzstan', code: 'KG' },
    { id: '+380', name: 'Ukraine', code: 'UA' },
    { id: '+84', name: 'Viet Nam', code: 'VN' },
    { id: '+90', name: 'Turkey', code: 'TR' },
    { id: '+994', name: 'Azerbaijan', code: 'AZ' },
    { id: '+374', name: 'Armenia', code: 'AM' },
    { id: '+371', name: 'Latvia', code: 'LV' },
    { id: '+91', name: 'India', code: 'IN' },
    { id: '+66', name: 'Thailand', code: 'TH' },
    { id: '+373', name: 'Moldova', code: 'MD' },
    { id: '+1', name: 'United States', code: 'US' },
    { id: '+81', name: 'Japan', code: 'JP' },
    { id: '+998', name: 'Uzbekistan', code: 'UZ' },
    { id: '+77', name: 'Kazakhstan', code: 'KZ' },
    { id: '+375', name: 'Belarus', code: 'BY' },
    { id: '+372', name: 'Estonia', code: 'EE' },
    { id: '+40', name: 'Romania', code: 'RO' },
    { id: '+82', name: 'Korea', code: 'KR' }
];

export default COUNTRIES;
